export const pagesTableListSelector = (state) => state.admin.pagesTable.list;
export const pagesTableMetaSelector = (state) => state.admin.pagesTable.meta;
export const searchResultCountersSelector = (state) => state.admin.pagesTable.searchResultCounters;
export const searchFiltersSelector = (state) => state.admin.pagesTable.searchFilters;
